import { render, staticRenderFns } from "./gate-form.vue?vue&type=template&id=38d389bb&"
import script from "./gate-form.vue?vue&type=script&lang=js&"
export * from "./gate-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports